import { render, staticRenderFns } from "./ClickBreakdown.vue?vue&type=template&id=44cd860c&scoped=true&"
import script from "./ClickBreakdown.vue?vue&type=script&lang=js&"
export * from "./ClickBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd860c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cd860c')) {
      api.createRecord('44cd860c', component.options)
    } else {
      api.reload('44cd860c', component.options)
    }
    module.hot.accept("./ClickBreakdown.vue?vue&type=template&id=44cd860c&scoped=true&", function () {
      api.rerender('44cd860c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Statistics/ClickBreakdown.vue"
export default component.exports